/** An account named with its masked number: "Wells Fargo Checking (••1008)". */
export default function formatAccountLabel(account: { name: string; mask: string }): string {
  return `${account.name} (••${account.mask})`;
}
